module.exports = __webpack_public_path__ + "img/br.7a264ca3.png";